export default __webpack_public_path__ + "static/media/default_avatar.3febf9f4.svg";